<template>
  <div>
    <h3>Experiential Learning</h3>
    <Summary :isLoadingSummary="isLoadingSummary" :summaryData="summaryData" />
    <CardGrid
      :isLoading="isLoadingTNA"
      :items="experientialLearningData"
      :isCanSelect="true"
      :type="'experiential'"
      @open-detail="handleOpenModalDetail"
      @select-change="$emit('select-change', ...arguments)"
    />
    <DetailTNAExperiential
      :isLoadingModal="isLoadingModal"
      :showDetailModal="showDetailModal"
      :selectedTNA="dataModal"
      @close="() => $emit('close-detail')"
      @open-add-activities="showAddActivitiesModal"
    />
    <AddActivitiesExperiential
      v-model="modalStacked.addActivities"
      :selectedTNA="dataModal"
      :selectTeams="selectTeams"
      @refresh="refreshData"
    />
  </div>
</template>

<script>
import AddActivitiesExperiential from "../modal/AddActivitiesExperiential.vue";
import DetailTNA from "../modal/DetailTNA.vue";
import DetailTNAExperiential from "../modal/DetailTNAExperiential.vue";
import CardGrid from "./card-grid.vue";
import Summary from "./summary.vue";
export default {
  name: "Experiential",
  emits: ["close-detail", "select-change"],
  components: {
    Summary,
    CardGrid,
    DetailTNA,
    DetailTNAExperiential,
    AddActivitiesExperiential,
  },
  data() {
    return {
      modalStacked: {
        addActivities: false,
      },
      selectTeams: [],
    };
  },

  props: {
    isLoadingSummary: Boolean,
    isLoadingTNA: Boolean,
    activeTab: String,
    summaryData: Object,
    experientialLearningData: Array,
    handleOpenModalDetail: Function,
    showDetailModal: Boolean,
    dataModal: Object,
    handleSelectChange: Function,
  },
  methods: {
    showAddActivitiesModal() {
      // Get teams from dataModal if available
      if (this.dataModal && this.dataModal.teams) {
        this.selectTeams = this.dataModal.teams.map((team) => ({
          nik: team.nik,
          label: `${team.name} (${team.nik})`,
          name: team.name,
        }));
      }
      this.modalStacked.addActivities = true;
    },
    refreshData() {
      // Emit event to parent to refresh data
      this.$emit("refresh-experiential");
    },
  },
};
</script>
